export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const campaignDoesNotBelongToCompany = (error) => {
  const unauthorizedStatus = error
    && error.response
    && error.response.status === 403;
  const unauthorizedMessage = error
    && error.response
    && error.response.data
    && error.response.data.message
    && error.response.data.message.includes('does not own campaign');
  return unauthorizedStatus && unauthorizedMessage;
};
